"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalDisclaimerLevel;
(function (GlobalDisclaimerLevel) {
    GlobalDisclaimerLevel["app"] = "app";
    GlobalDisclaimerLevel["page"] = "page";
})(GlobalDisclaimerLevel = exports.GlobalDisclaimerLevel || (exports.GlobalDisclaimerLevel = {}));
//# sourceMappingURL=GlobalDisclaimerLevel.js.map